import Tab2 from "../list/features/Tab2";
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {SalesRevenueByCompanyAllType, SalesRevenueViewInfoElementType, SalesSearchParamType} from "../list/interface";
import {salesSearchParamInit} from "../list/state";
import Filter from "../list/features/Filter";
import {useReadAllRevenueByCompany} from "../list/hooks/useReadAllRevenueByCompany";
import moment from "moment/moment";

export default function SalesCompany() {
    const {state} = useLocation()

    const [searchParam, setSearchParam] = useState<SalesSearchParamType>((() => ({
        ...salesSearchParamInit,
        revenueMonth: moment().month() + 1,
        revenueYear: moment().year(),
    }))());

    const {data: revenueAllByCompany} = useReadAllRevenueByCompany({
        param: searchParam,
        enabled: true
    })

    const dataList: SalesRevenueByCompanyAllType[] = revenueAllByCompany?.searchAllRevenueResList ?? []

    const hiddenColumnData: SalesRevenueViewInfoElementType[] = revenueAllByCompany?.revenueViewInfoVOList ?? []

    useEffect(() => {
        if (state && state.stateSearchParam) {
            setSearchParam(state.stateSearchParam)
        }
    }, [state]);

    return <>
        <Filter searchParam={searchParam} setSearchParam={setSearchParam} pageType={"company"}/>
        <Tab2 searchParam={searchParam}
              dataList={dataList}
              hiddenColumnData={hiddenColumnData}
              monthView={"full"}/>
    </>
}